import httpClient from '../../shared/http/http-client';

export default class AdminNavbarDropdownService {
  http;

  constructor() {
    this.http = httpClient;
  }

  /**
   * Get all navbar dropdowns.
   * @returns - All navbar dropdowns as an array.
   */
  async getAllNavbarDropdowns() {
    return this.http.get('admin/navbar-dropdown')
      .then((response) => {
        return response.data;
      })
      .catch(err => {
        console.log(err);
        return err;
      });
  }

  /**
   * Create a new dropdown.
   * REQUIRED => [title].
   * @returns - The created dropdown.
   */
  async createNewNavbarDropdown(dropdown) {
    return this.http.post('admin/navbar-dropdown', dropdown)
      .then((response) => {
        return response.data;
      })
      .catch(err => {
        console.log(err);
        return err;
      });
  }

  /**
  * Update a navbar dropdown.
  * OPTIONAL => [title]
  * @returns - The updated navbar dropdown.
  */
  async updateNavbarDropdown(navbarDropdownId, updatedParams) {
    return this.http.post(`admin/navbar-dropdown/${navbarDropdownId}/update`, updatedParams)
      .then((response) => {
        return response.data;
      })
      .catch(err => {
        console.log(err);
        return err;
      });
  }

  async deleteNavbarDropdown(navbarDropdownId) {
    return this.http.post(`admin/navbar-dropdown/${navbarDropdownId}/delete`, {})
      .then((response) => {
        return response.data;
      })
      .catch(err => {
        console.log(err);
        return err;
      });
  }

}
